import { axiosInstance } from "common/network";

// Downloads one transfer format of a didimo. The format's self link
// (…/results/<name>) is an authenticated API endpoint that, with
// Didimo-Follow-Uri:false, returns JSON holding a short-lived presigned S3 URL.
// We fetch that URL with the authenticated client, then hand the presigned URL
// to the browser — the presigned URL carries its own auth, so no bearer token
// reaches S3. Throws on failure so callers can surface an error.
export const downloadDidimoFormat = async (format, { newTab = false } = {}) => {
  const self = format?.__links?.self;
  if (!self) throw new Error("No download link for this format");
  const response = await axiosInstance.get(self, {
    headers: { "Didimo-Follow-Uri": "false" },
  });
  const uri = response?.data?.uri || response?.data?.Uri;
  if (!uri) throw new Error("No download URL returned");
  const a = document.createElement("a");
  a.href = uri;
  a.rel = "noopener";
  // Some resources (e.g. photo inputs) render inline in the browser instead of
  // downloading, which would navigate the current tab — open those in a new one.
  if (newTab) a.target = "_blank";
  document.body.appendChild(a);
  a.click();
  a.remove();
};
